import React from 'react';
import styled from 'styled-components';

const NinjaLayoutDiv = styled.div`
  ${p => (p.hidden ? 'display: none;' : '')}
`;

const NinjaLayout = ({ hidden = false, children }) => (
  <NinjaLayoutDiv hidden={hidden}>
    { children }
  </NinjaLayoutDiv>
);

export default NinjaLayout;
